module.exports = __webpack_public_path__ + "static/media/cadeado-icon.2c3353b3.svg";